export const user = {
  list: 'mp-smart-admp/v1/user/listUser',
}
